"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6644],{

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ViewMain; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./src/utils/links.ts
const normalizeTrailingSlash = (url)=>{
    if (url === "/") {
        return url;
    }
    if (url.endsWith("/")) {
        return url.slice(0, -1);
    }
    return url;
};
const getUrlValue = (url)=>url !== "/" ? url.split("/").length : 0;
const compareUrlsBySpecificity = (urlA, urlB)=>getUrlValue(urlA) - getUrlValue(urlB);

// EXTERNAL MODULE: ./src/navigation/urls.ts
var urls = __webpack_require__(6633);
;// CONCATENATED MODULE: ./src/navigation/pages/about.ts

const ABOUT_US_NAVIGATION = {
    pageUrl: urls/* getAboutUsUrl */.Bx(),
    currentLink: {
        text: "About Us",
        href: urls/* getAboutUsUrl */.Bx()
    },
    links: [
        {
            text: "Our Brands",
            href: urls/* getOurBrandsUrl */.nJ()
        },
        {
            text: "Our History",
            href: urls/* getHistoryUrl */.ek()
        },
        {
            text: "Our Management Team",
            href: urls/* getManagementTeamUrl */.De()
        },
        {
            text: "News and Updates",
            href: urls/* getNewsUrl */.Xx()
        }
    ]
};

;// CONCATENATED MODULE: ./src/navigation/pages/dei.ts

const DIVERSITY_EQUITY_INCLUSION_NAVIGATION = {
    pageUrl: urls/* getDEIUrl */.iw(),
    currentLink: {
        text: "Diversity and Inclusion",
        href: urls/* getDEIUrl */.iw()
    },
    links: [
        {
            text: "Statement",
            href: urls/* getDEIStatementUrl */.CJ()
        },
        {
            text: "Our Commitment",
            href: urls/* getDEICommitmentUrl */.Sx()
        },
        {
            text: "Policy",
            href: urls/* getDEIPolicyUrl */.LZ()
        },
        {
            text: "Breaches",
            href: urls/* getDEIBrachesUrl */.ap()
        }
    ]
};

// EXTERNAL MODULE: ./src/utils/featureToggles/index.ts + 1 modules
var featureToggles = __webpack_require__(7098);
;// CONCATENATED MODULE: ./src/navigation/pages/foundation.ts


const FOUNDATION_NAVIGATION = {
    pageUrl: urls/* getFoundationUrl */.XA(),
    currentLink: {
        text: "Foundation",
        href: urls/* getFoundationUrl */.XA()
    },
    links: [
        {
            text: "Apply for Funding",
            href: urls/* getFoundationApplicationUrl */.R_()
        },
        {
            text: "Funded Projects",
            href: urls/* getFoundationProjectsUrl */.Ee()
        }
    ]
};
if (featureToggles/* featureToggles.foundationDonations */.f.foundationDonations) {
    FOUNDATION_NAVIGATION.links.push({
        text: "Donate",
        href: urls/* getFoundationDonationUrl */.pr()
    });
}

;// CONCATENATED MODULE: ./src/navigation/pages/investors.ts

const INVESTORS_NAVIGATION = {
    pageUrl: urls/* getInvestorsUrl */.Ye(),
    currentLink: {
        text: "Investor relations",
        href: urls/* getInvestorsUrl */.Ye()
    },
    links: [
        {
            text: "Financial Information",
            href: urls/* getInvestorsReportListUrl */.M9("annual"),
            matchHref: urls/* getInvestorsReportUrl */.mz()
        },
        {
            text: "Announcements",
            href: urls/* getFinancialAnnouncementsUrl */.sb()
        },
        {
            text: "News and Updates",
            href: urls/* getFinancialNewsUrl */.kw()
        }
    ]
};

;// CONCATENATED MODULE: ./src/navigation/pages/sustainability.ts

const SUSTAINABILITY_NAVIGATION = {
    pageUrl: urls/* getSustainabilityUrl */.E_(),
    currentLink: {
        text: "Sustainability",
        href: urls/* getSustainabilityUrl */.E_()
    },
    links: [
        {
            text: "Environment",
            href: urls/* getSustainabilityEnvironmentUrl */.kX()
        },
        {
            text: "Social",
            href: urls/* getSustainabilitySocialUrl */.Hl()
        },
        {
            text: "Governance",
            href: urls/* getSustainabilityGovernanceUrl */.d()
        },
        {
            text: "Reports and Policies",
            href: urls/* getSustainabilityReportListUrl */.ii("esg"),
            matchHref: urls/* getSustainabilityReportsUrl */.ml()
        }
    ]
};

;// CONCATENATED MODULE: ./src/navigation/getSubNavigation.ts






const NAVIGATION_TREE = [
    ABOUT_US_NAVIGATION,
    DIVERSITY_EQUITY_INCLUSION_NAVIGATION,
    SUSTAINABILITY_NAVIGATION,
    INVESTORS_NAVIGATION,
    FOUNDATION_NAVIGATION
];
const getSubNavigation = (currentPath)=>{
    const prioritizedNavigationTree = NAVIGATION_TREE.toSorted((navA, navB)=>compareUrlsBySpecificity(navA.pageUrl, navB.pageUrl));
    var ref;
    return (ref = prioritizedNavigationTree.find((nav)=>currentPath.startsWith(nav.pageUrl))) !== null && ref !== void 0 ? ref : null;
};

// EXTERNAL MODULE: ./src/components/atoms/StyledLink.tsx
var StyledLink = __webpack_require__(7169);
// EXTERNAL MODULE: ./src/components/icons/System/index.tsx + 298 modules
var System = __webpack_require__(3857);
// EXTERNAL MODULE: ./src/components/atoms/Button.tsx
var Button = __webpack_require__(1280);
// EXTERNAL MODULE: ./src/constants/ButtonModes.ts
var ButtonModes = __webpack_require__(9413);
;// CONCATENATED MODULE: ./src/components/molecules/SkipToMainContent.tsx



const MAIN_CONTENT_ID = "main-content";
const SkipToMainContentButton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        mode: ButtonModes/* ButtonModes.secondary */.r.secondary,
        className: "absolute left-[-9999px] m-4 z-10 active:left-0 focus:left-0",
        href: "#".concat(MAIN_CONTENT_ID),
        children: "Skip to Main Content"
    });
const SkipToMainContentTarget = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-[1px] h-[1px] overflow-hidden float-right",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            id: MAIN_CONTENT_ID,
            tabIndex: -1,
            children: "-"
        })
    });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/hooks/useIsVisible.tsx + 1 modules
var useIsVisible = __webpack_require__(259);
;// CONCATENATED MODULE: ./src/components/molecules/SubNavigationLink.tsx






const INTERSECTION_OPTIONS = {
    threshold: 1.0
};
const SubNavigationLink = (param)=>{
    let { className , link , isActive  } = param;
    const ref = (0,react.useRef)(null);
    const isVisible = (0,useIsVisible/* useIsVisible */.O)(ref, INTERSECTION_OPTIONS);
    (0,react.useEffect)(()=>{
        if (isActive && !isVisible) {
            var ref1, ref2;
            (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.parentElement) === null || ref2 === void 0 ? void 0 : ref2.scrollTo({
                behavior: "smooth",
                left: ref.current.offsetLeft
            });
        }
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        ref: ref,
        className: (0,clsx_m/* default */.Z)(className, "mr-4 list-none tablet:mr-6 shrink-0 snap-start scroll-m-6"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            size: "small",
            mode: isActive ? ButtonModes/* ButtonModes.primary */.r.primary : ButtonModes/* ButtonModes.secondaryWhite */.r.secondaryWhite,
            href: link.href,
            children: link.text
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(4045);
;// CONCATENATED MODULE: ./src/components/organisms/SubNavigation.tsx






const scrollPosition = {
    path: null,
    left: 0
};
const SubNavigation = (param)=>{
    let { currentLink , links  } = param;
    const { asPath  } = (0,router.useRouter)();
    const isPathCurrentLinkExact = normalizeTrailingSlash(asPath) === normalizeTrailingSlash(currentLink.href);
    const scrollRef = (0,react.useRef)(null);
    const handleScroll = (event)=>{
        scrollPosition.path = currentLink.href;
        scrollPosition.left = event.currentTarget.scrollLeft;
    };
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(()=>{
        const restoredPosition = scrollPosition.path === currentLink.href ? scrollPosition.left : null;
        if (scrollRef.current && restoredPosition !== null) {
            scrollRef.current.scrollTo(restoredPosition, 0);
        }
    }, [
        currentLink
    ]);
    var _matchHref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-8 mb-10 tablet:mb-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            className: "m-auto max-w-page-content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                ref: scrollRef,
                className: "flex py-1 -my-1 overflow-x-scroll snap-x __header:place-content-center __header:overflow-x-auto scrollbar-hide",
                onScroll: handleScroll,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationLink, {
                        className: "pl-6 __header:hidden",
                        link: currentLink,
                        isActive: isPathCurrentLinkExact
                    }),
                    links.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationLink, {
                            link: link,
                            isActive: normalizeTrailingSlash(asPath).startsWith(normalizeTrailingSlash((_matchHref = link.matchHref) !== null && _matchHref !== void 0 ? _matchHref : link.href))
                        }, link.href))
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/atoms/Logo.tsx + 2 modules
var Logo = __webpack_require__(8925);
// EXTERNAL MODULE: ./src/components/atoms/IconButton.tsx
var IconButton = __webpack_require__(1051);
;// CONCATENATED MODULE: ./src/components/atoms/HeaderMenuToggle.tsx




const HeaderMenuToggle = (param)=>{
    let { setIsMenuOpen , isMenuOpen  } = param;
    const handleMenuOpen = (0,react.useCallback)(()=>{
        setIsMenuOpen(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        className: "ml-[-12px] hover:bg-current px-0",
        icon: isMenuOpen ? System/* CloseLine */.OhS : System/* Menu2Line */.nVL,
        isDark: !isMenuOpen,
        "aria-label": "Toggle menu",
        onClick: handleMenuOpen
    });
};
/* harmony default export */ var atoms_HeaderMenuToggle = (HeaderMenuToggle);

// EXTERNAL MODULE: ./src/hooks/useKeypress.ts
var useKeypress = __webpack_require__(2466);
// EXTERNAL MODULE: ./src/navigation/mainNavigation.ts + 1 modules
var mainNavigation = __webpack_require__(3951);
// EXTERNAL MODULE: ./node_modules/react-focus-lock/dist/es2015/index.js + 32 modules
var es2015 = __webpack_require__(4082);
// EXTERNAL MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js + 16 modules
var Combination = __webpack_require__(1860);
// EXTERNAL MODULE: ./src/components/atoms/Icon.tsx
var Icon = __webpack_require__(7697);
;// CONCATENATED MODULE: ./src/components/organisms/SideMenu.tsx











const SideMenu = (param)=>{
    let { setIsMenuOpen , isMenuOpen  } = param;
    const handleClick = (0,react.useCallback)(()=>{
        setIsMenuOpen(false);
    }, []);
    const LockFocusWhenOpen = isMenuOpen ? es2015/* default */.ZP : react.Fragment;
    const RemoveScrollWhenOpen = isMenuOpen ? Combination/* default */.Z : react.Fragment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LockFocusWhenOpen, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RemoveScrollWhenOpen, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("side-menu w-full laptop:w-[420px] bg-hrg-red-140 overflow-auto", {
                    isMenuOpen,
                    invisible: !isMenuOpen
                }),
                "data-active": isMenuOpen,
                role: "navigation",
                "aria-label": "side menu",
                "aria-hidden": !isMenuOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-between w-full h-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mx-8 mt-4 mb-8 tablet:mb-16",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_HeaderMenuToggle, {
                                            isMenuOpen: isMenuOpen,
                                            setIsMenuOpen: setIsMenuOpen
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                            whiteText: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col mt-8 mb-4 tablet:mt-16",
                                    children: mainNavigation/* MAIN_NAVIGATION.map */.E.map((link)=>link.isNewTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: link.href,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "mb-4 text-white h2-m",
                                            children: link.text
                                        }, link.href) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: link.href,
                                            prefetch: false,
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "mb-4 text-white h2-m",
                                                onClick: handleClick,
                                                children: link.text
                                            })
                                        }, link.href))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1 px-8 py-10 bg-hrg-red-90 footer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mb-8 text-white h2-m",
                                    children: "Go to"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-col",
                                    children: mainNavigation/* GO_TO_LINKS.map */.M.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            href: link.href,
                                            className: "flex justify-between w-full mb-4 text-white capitalize h4-m",
                                            children: [
                                                link.text,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    icon: System/* ArrowRightLine */.dT3,
                                                    fill: "text-white"
                                                })
                                            ]
                                        }, link.href))
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var organisms_SideMenu = (SideMenu);

;// CONCATENATED MODULE: ./src/components/organisms/Header.tsx












const isErrorPath = (path)=>path.startsWith("/404") || path.startsWith("/_error");
const MAIN_NAVIGATION_BY_SPECIFICITY = mainNavigation/* MAIN_NAVIGATION.toSorted */.E.toSorted((navA, navB)=>compareUrlsBySpecificity(navB.href, navA.href));
const isMostSpecificSelectedPath = (currentPath, comparePath)=>{
    var ref;
    return ((ref = MAIN_NAVIGATION_BY_SPECIFICITY.find((link)=>currentPath.startsWith(link.href))) === null || ref === void 0 ? void 0 : ref.href) === comparePath;
};
const Header = ()=>{
    const { asPath , route  } = (0,router.useRouter)();
    const [isMenuOpen, setIsMenuOpen] = (0,react.useState)(false);
    (0,useKeypress/* useKeypress */.u)("Escape", ()=>{
        if (isMenuOpen) {
            setIsMenuOpen(false);
        }
    }, [
        isMenuOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "grid items-center grid-cols-[minmax(min-content,1fr)_minmax(min-content,max-content)_1fr] px-8 py-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center mr-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_HeaderMenuToggle, {
                        isMenuOpen: isMenuOpen,
                        setIsMenuOpen: setIsMenuOpen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_SideMenu, {
                        isMenuOpen: isMenuOpen,
                        setIsMenuOpen: setIsMenuOpen
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipToMainContentButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "justify-center hidden w-full __header:flex",
                children: mainNavigation/* MAIN_NAVIGATION.map */.E.map((link)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mr-4 tablet:mr-4 laptop:mr-6 desktop:mr-10 last:mr-0",
                        children: link.isNewTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: link.href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (0,clsx_m/* default */.Z)("font-medium text-d-caption block w-full text-center", {
                                "text-hrg-red-100": !isErrorPath(route) && isMostSpecificSelectedPath(asPath, link.href)
                            }),
                            children: link.text
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: link.href,
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (0,clsx_m/* default */.Z)("font-medium text-d-caption block w-full text-center", {
                                    "text-hrg-red-100": !isErrorPath(route) && isMostSpecificSelectedPath(asPath, link.href)
                                }),
                                children: link.text
                            })
                        })
                    }, link.href))
            })
        ]
    });
};
/* harmony default export */ var organisms_Header = (Header);

// EXTERNAL MODULE: ./src/components/organisms/Footer.tsx + 193 modules
var Footer = __webpack_require__(9230);
;// CONCATENATED MODULE: ./src/components/organisms/ViewMain.tsx










const ViewMain = (param)=>{
    let { children , navigation =true , backNavigation , footerMargin =true , contenWrapper =false  } = param;
    const { asPath  } = (0,router.useRouter)();
    const subNavigation = getSubNavigation(asPath);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 grid-rows-[min-content_1fr_min-content]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    navigation && subNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigation, {
                        currentLink: subNavigation.currentLink,
                        links: subNavigation.links
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: (0,clsx_m/* default */.Z)("tablet:mt-12 min-h-[75vh]", contenWrapper && "content-wrapper", footerMargin && "mb-16 tablet:mb-30"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipToMainContentTarget, {}),
                            backNavigation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "content-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink/* StyledLink */.F, {
                                    className: "mb-14",
                                    link: backNavigation,
                                    iconPosition: "left",
                                    icon: System/* ArrowLeftLine */.CCt,
                                    iconClassName: "mr-4"
                                })
                            }),
                            children
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};


/***/ })

}]);